import { render, staticRenderFns } from "./default.vue?vue&type=template&id=d5a92896&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.9.8_rqhk6tgffcjxa27soxhh2o2ymu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports